<template>
    <div class="pagination grid grid-gap-16 align-items-center">
        <div class="pagination__results col-12 col-sm-6">
            {{ resultsText }}
        </div>

        <v-pagination
            class="button button--pagination pagination__pages col-12 col-sm-6 justify-self-sm-end"
            :model-value="currentPage"
            :length="pageCount"
            :total-visible="3"
            density="comfortable"
            @update:model-value="$emit('page-change', $event)"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { getPageCount } from '../helpers'

const props = defineProps({
  page: {
    type: Number,
    default: 1,
  },
  perPage: {
    type: Number,
    default: 10,
  },
  totalResults: {
    type: Number,
    default: 0,
  },
})

defineEmits(['page-change'])

const pageCount = computed(() => getPageCount(props.totalResults, props.perPage))

const currentPage = computed(() => Math.min(Math.max(props.page, 1), pageCount.value))

const resultsText = computed(() => {
  if (!props.totalResults) {
    return 'Prikazuje se 0 od 0'
  }

  const from = (currentPage.value - 1) * props.perPage + 1
  const to = Math.min(currentPage.value * props.perPage, props.totalResults)

  return `Prikazuje se ${from}-${to} od ${props.totalResults}`
})
</script>

<style
    scoped
    lang="scss"
>
.pagination {
    width: 100%;
    padding: 16px 0;

    &__results {
        color: var(--color-text-muted);
        font-size: clamp-bp("sm", "xl", 13, 14);
        font-style: normal;
        font-weight: 300;
        line-height: clamp-bp("sm", "xl", 19, 21);
        white-space: nowrap;
    }

    &__pages {
        flex: 0 0 auto;
        max-width: 100%;
        overflow-x: auto;

        @include breakpoint-up("sm") {
            max-width: none;
            overflow-x: visible;
        }
    }

    :deep(.v-pagination__list) {
        align-items: center;
        justify-content: flex-end;
        gap: 0;
        width: auto;
        margin: 0;
        padding: 0;
    }

    :deep(.v-pagination__list > li) {
        margin: 0;
    }

    :deep(.v-pagination__list > li + li) {
        margin-left: -1px;
    }
}

</style>
